import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import IconChevronRight from '@spothero/icons/chevron-right';
import {
    Divider,
    DrawerBody,
    DrawerContainer,
    DrawerContent,
    DrawerOverlay,
    Icon,
    Link,
} from '@spothero/ui';

import MobileNavigationHeader from './MobileNavigationHeader';
import SubMenuGroup from './SubMenuGroup';

const subMenuLinkStyleProps = {
    variant: 'tertiary',
    fontSize: 'sm',
    paddingY: 2,
    paddingX: 3,
    color: 'black',
    display: 'flex',
    alignItems: 'center',
};

const SubMenu = ({
    isOpen,
    label,
    menuContentArray,
    onBackButtonClick,
    onClick,
    onClose,
    onMenuItemClick,
}) => {
    return (
        <>
            <Link onClick={onClick} {...subMenuLinkStyleProps}>
                {label}{' '}
                <Icon as={IconChevronRight} boxSize={4} marginLeft={1.5} />
            </Link>
            <DrawerContainer isOpen={isOpen} onClose={onClose}>
                <DrawerOverlay />
                <DrawerContent data-testid={label}>
                    <MobileNavigationHeader
                        showBackButton
                        onBackButtonClick={onBackButtonClick}
                    />
                    <DrawerBody>
                        {menuContentArray.map(({heading, submenu}, index) => {
                            const showDivider =
                                index < menuContentArray.length - 1;

                            return (
                                <Fragment key={index}>
                                    <SubMenuGroup
                                        key={index}
                                        heading={heading}
                                        submenu={submenu}
                                        onClick={onMenuItemClick}
                                    />
                                    {showDivider && <Divider marginY={4} />}
                                </Fragment>
                            );
                        })}
                    </DrawerBody>
                </DrawerContent>
            </DrawerContainer>
        </>
    );
};

SubMenu.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    menuContentArray: PropTypes.arrayOf(
        PropTypes.shape({
            heading: PropTypes.string.isRequired,
            submenu: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    subtitle: PropTypes.string,
                    route: PropTypes.string.isRequired,
                    isDisabled: PropTypes.bool,
                })
            ),
        })
    ).isRequired,
    onBackButtonClick: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onMenuItemClick: PropTypes.func.isRequired,
};

export default SubMenu;
